import React from 'react';

export default function SearchIcon({ fill = '#FFF', ...rest }: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.2934 4.56572C6.81914 4.56572 4.00273 7.38213 4.00273 10.8563C4.00273 14.3306 6.81914 17.147 10.2934 17.147C12.0307 17.147 13.6022 16.4438 14.7415 15.3045C15.8808 14.1652 16.584 12.5937 16.584 10.8563C16.584 7.38213 13.7676 4.56572 10.2934 4.56572ZM2.28711 10.8563C2.28711 6.43462 5.87163 2.8501 10.2934 2.8501C14.7151 2.8501 18.2996 6.43462 18.2996 10.8563C18.2996 12.7579 17.6359 14.5056 16.5288 15.8786L20.3359 19.6857C20.6709 20.0207 20.6709 20.5639 20.3359 20.8988C20.0009 21.2338 19.4577 21.2338 19.1227 20.8988L15.3156 17.0918C13.9426 18.1989 12.1949 18.8626 10.2934 18.8626C5.87163 18.8626 2.28711 15.2781 2.28711 10.8563Z"
                fill={fill}
            />
        </svg>
    );
}
